import initSdk, {
  canonicalize_email,
  email_hash,
  parse_google_jwt,
  prove_claim,
} from "@zkfold/smart-wallet-sdk";
import type { ChainTarget, ClaimRequest, GoogleKeyResponse, ParsedJwt } from "./types";

interface ClaimProofInput {
  compactJwt: string;
  googleKey: GoogleKeyResponse;
  chain: (ChainTarget & { type: "cardano" }) | (ChainTarget & { type: "evm"; escrow: string });
  refs: string[];
  to: string;
  relayer: string;
}

let sdkInit: Promise<void> | null = null;

export async function canonicalizeSendEmail(email: string): Promise<string> {
  await ensureSdk();
  return canonicalize_email(email);
}

export async function emailHash(email: string): Promise<string> {
  await ensureSdk();
  return email_hash(email);
}

export async function parseGoogleJwt(compactJwt: string): Promise<ParsedJwt> {
  await ensureSdk();
  return JSON.parse(parse_google_jwt(compactJwt)) as ParsedJwt;
}

export async function buildClaimRequest(input: ClaimProofInput): Promise<ClaimRequest> {
  await ensureSdk();
  const requestJson = prove_claim(JSON.stringify(input));
  return JSON.parse(requestJson) as ClaimRequest;
}

async function ensureSdk(): Promise<void> {
  if (sdkInit === null) {
    sdkInit = initSdk().then(() => undefined);
  }
  await sdkInit;
}
